import { format, unwrapFunctionStore } from 'svelte-i18n';

import { integrationsSettingsStore } from '@client/stores/page-settings';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const clickCreateIntegration = {
  element: '.footer-actions > button',
  popover: {
    title: 'Create Your Integration',
    description:
      "After you've filled out the form, click the <strong>&quot;Create Integration&quot;</strong> button. You'll be taken to the <strong>integration editor</strong> page where you can view your integration and more.",
    side: 'bottom',
    align: 'center',
    onNextClick: () => {
      const close = document.querySelector('.close');

      if (close) {
        integrationsSettingsStore.subscribe((integrations) => {
          integrations.tours.createHasToured = true;
        })();

        close.click();

        GLOBAL_DRIVER_OBJECT.destroy();
      }
    }
  }
};
